// import React, { useContext, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { ContainerInput } from "./styles";
import { Select } from "../Select";
import { InputMask } from "../InputMask";
import { Input } from "../Input";
import { MyDynamicInputTextTypes } from "./types";

export const MyDynamicInput = ({ data, control }: MyDynamicInputTextTypes) => {
	switch (data.type) {
		case "email":
		case "text":
			return (
				<ContainerInput className='dynamic-input-container'>
					<Controller
						control={control}
						name={data.name}
						render={({ field, fieldState: { error } }) => {
							return (
								<>
									<Input
										{...field}
										onChange={field.onChange}
										onBlur={field.onBlur}
										value={field.value}
										name={field.name}
										{...data.defaultProps}
										disabled={data?.disabled}
										control={control}
										watchField={data.watchField}
										inputRef={field.ref}
										placeholder={
											data.placeholder
												? data.placeholder
												: ""
										}
										type={data.type}
									/>
									{error ? <p>{error.message}</p> : ""}
								</>
							);
						}}
					/>
				</ContainerInput>
			);
		case "checklist":
			return (
				<ContainerInput className='dynamic-input-container'>
					<Controller
						control={control}
						name={data.name}
						render={({ field, fieldState: { error } }) => {
							return (
								<>
									<Select
										key={data.name}
										onChange={field.onChange}
										onBlur={field.onBlur}
										value={field.value}
										name={field.name}
										inputRef={field.ref}
										required={data.required}
										placeholder={data.title}
										control={control}
										watchField={data.watchField}
										options={
											data.options as {
												label: string;
												value: string;
											}[]
										}
									/>
									{error ? <p>{error.message}</p> : ""}
								</>
							);
						}}
					/>
				</ContainerInput>
			);

		case "select":
			return (
				<ContainerInput className='dynamic-input-container'>
					<Controller
						control={control}
						name={data.name}
						render={({ field, fieldState: { error } }) => {
							return (
								<>
									<Select
										key={data.name}
										onChange={field.onChange}
										onBlur={field.onBlur}
										value={field.value}
										name={field.name}
										inputRef={field.ref}
										required={data.required}
										placeholder={data.title}
										control={control}
										watchField={data.watchField}
										options={
											data.options as {
												label: string;
												value: string;
											}[]
										}
									/>
									{error ? <p>{error.message}</p> : ""}
								</>
							);
						}}
					/>
				</ContainerInput>
			);

		case "date":
		case "mask":
		case "number":
			return (
				<ContainerInput className='dynamic-input-container'>
					<Controller
						name={data.name}
						control={control}
						render={({ field, fieldState: { error } }) => {
							return (
								<>
									<InputMask
										onChange={field.onChange}
										value={field.value}
										inputRef={field.ref}
										name={data.name}
										mask={
											data.mask as
												| string
												| {
														prefix: string;
														type: string;
												  }
										}
										placeholder={data.title}
									/>
									{error ? <p>{error.message}</p> : ""}
								</>
							);
						}}
					/>
				</ContainerInput>
			);
	}

	return <div>Nada ainda</div>;
};
